// Store closure dates (admin → Stores → Edit Pickup Time → Store Closure
// Dates). Kept here like the store time zone, so every ready date
// calculation skips them (reported issues 3.f).

export interface IStoreClosure {
  /** YYYY-MM-DD */
  date: string;
  reason?: string;
  /** Admin-set ready dates for tickets that skip this holiday (YYYY-MM-DD) */
  specialReadyDate?: string | null;
  regularReadyDate?: string | null;
}

type ClosureInput =
  | string
  | {
      closureDate: string;
      reason?: string;
      specialReadyDate?: string | null;
      regularReadyDate?: string | null;
    };

let closures = new Map<string, IStoreClosure>();

export const setStoreClosureDates = (dates?: ClosureInput[] | null) => {
  closures = new Map(
    (dates ?? []).map((d) => {
      const closure: IStoreClosure =
        typeof d === "string"
          ? { date: d.slice(0, 10) }
          : {
              date: d.closureDate.slice(0, 10),
              reason: d.reason,
              specialReadyDate: d.specialReadyDate?.slice(0, 10) ?? null,
              regularReadyDate: d.regularReadyDate?.slice(0, 10) ?? null,
            };
      return [closure.date, closure];
    })
  );
};

export const dayKey = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;

/** The closure (holiday) on `date`'s calendar day, if any. */
export const storeClosureOn = (date: Date) => closures.get(dayKey(date));

/** True if the store is closed (holiday) on `date`'s calendar day. */
export const isStoreClosedOn = (date: Date) => closures.has(dayKey(date));
